// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#f3f3f3","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#0d47a1","menuHover":"#093d86","subMenuBg":"#0d47a1","subMenuHover":"#093d86","sideBarWidth":"210px","green":"#30B08F","lightPrimary":"#1565c0","theme":"#0d47a1"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 7